import { Box, Chip, Typography } from "@mui/material"
import type { FC } from "react"

interface CompanyHeaderFieldProps {
  label: string
  value: string
  chipColor?: "primary" | "gray"
}

export const CompanyHeaderField: FC<CompanyHeaderFieldProps> = ({ label, value, chipColor = "gray" }) => (
  <Box className='flex items-center gap-2'>
    <Typography variant='body2' className='text-gray-700'>
      {label}
    </Typography>
    <Chip label={value} className={`rounded-md ${chipColor === "primary" ? "bg-primary-200" : "bg-gray-200"}`} />
  </Box>
)
